export function filterAllowedRoutes(section, userPrivileges) {
  if (!section || !section.children) return null;

  const allowedChildren = section.children.filter((child) => {

    if (child.privilege) {
      return userPrivileges.includes(child.privilege);
    }

    if (child.privileges) {
      return child.privileges.every((p) => userPrivileges.includes(p));
    }

    // No privilege required
    return true;
  });

  // If none allowed, hide the whole section
  if (allowedChildren.length === 0) {
    return null;
  }

  return {
    ...section,
    children: allowedChildren,
  };
}
